// localStorage-backed user settings for HQ Signal demo.

const STORAGE_KEY = "hq-signal:settings:v1";

export const DEFAULT_SETTINGS = {
  departments:
    "Engineering, Product, Design, Marketing, Sales, Finance, People Ops, Operations",
  floors: 3,
  workplaces: 300,
  defaultRoomCapacity: 8,
  hoursStart: "08:30",
  hoursEnd: "19:00",
  threshold: "10",
  noShowDelay: "10",
  granularity: "daily",
  costPerDesk: 6000, // €/year fully loaded annual cost per desk
  currency: "EUR",
};

export function loadSettings() {
  if (typeof window === "undefined") return { ...DEFAULT_SETTINGS };
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_SETTINGS, ...parsed };
  } catch (e) {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveSettings(settings) {
  if (typeof window === "undefined") return;
  try {
    const merged = { ...DEFAULT_SETTINGS, ...settings };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  } catch (e) {
    // ignore quota / serialization errors in demo
  }
}
